export class WorkFlowMessageModel {
    [x: string]: any;

    public id: any;
    public tracking_id: string;
    public message_content: string;
    public dispute: string;
    public created_by: string;
    public created_dt: any;
    public employee_id: any;
    public kpiid: any;
    public complanid: any;
    public sc_emp_id: any;
    public flow_id: number;
    public message: string;
    public status: string;
    public kom_feed_id: any;
    public accnum: any;
    public sales_rep_id: string;
    public calRunId: string;
    public finalizeddate: string;
    public accnumber: string;
    public disputetype: string;
    public mob_feed_id: any;
    public recordType: any;
    public complex_kpiid: any;
    public loggedin_role: any;
    public cust: any;
    public cust_id: any;

    public saleschannel: any;
    public commplan: any;
    public fromdt: any;
    public todt: any;
    public stat: any;

    constructor() {
        this.saleschannel = "";
        this.commplan = "";
        this.fromdt = "";
        this.todt = "";
        this.stat = "";

        this.cust = "";
        this.cust_id = "";
        this.loggedin_role = "";
        this.complex_kpiid = "";
        this.recordType = "";
        this.mob_feed_id = "";
        this.accnum = "";
        this.disputetype = "";
        this.accnumber = "";
        this.finalizeddate = "";
        this.calRunId = "";
        this.sales_rep_id = "";
        this.kom_feed_id = "";
        this.status = "";
        this.id = null;
        this.tracking_id = "";
        this.message_content = "";
        this.dispute = "";
        this.created_by = "";
        this.created_dt = "";
        this.employee_id = "";
        this.kpiid = "";
        this.complanid = "";
        this.sc_emp_id = "";
        this.flow_id = 0;
        this.message = "";
    }
}
